import { string } from 'yup';

import { getQuillPlainText } from '../../components/baseV2';

import type { FormikTouched } from 'formik';
import type { Moment } from 'moment';
import type { RichTextSchemaOptions } from './types';

export function getAllFieldsTouched<TValues extends object>(
  values: TValues,
): FormikTouched<TValues> {
  return Object.keys(values).reduce<FormikTouched<TValues>>(
    (touched, fieldName) => ({
      ...touched,
      [fieldName]: true,
    }),
    {},
  );
}

export function toMonthStart(value: Moment | null | undefined): Moment | null {
  return value != null ? value.clone().startOf('month') : null;
}

// Rich text values carry Quill markup, so the limits apply to the text the clinician typed.
export function buildRichTextSchema({
  minLength,
  maxLength,
  minMessage,
  maxMessage,
}: RichTextSchemaOptions) {
  return string()
    .test('min-text-length', minMessage, (value) => getQuillPlainText(value).length >= minLength)
    .test('max-text-length', maxMessage, (value) => getQuillPlainText(value).length <= maxLength)
    .required();
}
